class Options {
  useSkills: boolean = true;
  winningRank: number = 0;
  autoRecording: boolean = true;
  winnerCount: number = 1;
}

const options = new Options();
export default options;
